import React, { useState } from "react";
import { Button, Container, Stack, Select, Input, FormLabel, FormControl } from "@chakra-ui/react";
import { CheckIcon } from "@chakra-ui/icons";
import { Header } from "./Header";

function TaskForm({ clients, clientProjects, tasks, taskData, handleClientChange, handleProjectChange, handleTaskChange, handleAddTask }) {
  const [isOtherTask, setIsOtherTask] = useState(false);
  return (
    <Container width={"full"} maxW={"unset"}>
      <Stack spacing={4} mb={4} direction={"column"}>
        <Header fontSize={{ base: "sm", md: "md" }}>Ajouter une tache à votre journée :</Header>
        <Stack as={"form"} direction={{ base: "column", md: "row" }} width={"full"} spacing={{ base: 4, md: 2 }}>
          <FormControl>
            <FormLabel htmlFor="client">Client : </FormLabel>
            <Select id="client" name="clientId" onChange={handleClientChange} size={{ base: "sm", md: "md" }}>
              <option value="">-- Choisir --</option>
              {clients
                .sort((a, b) => a.client_name.localeCompare(b.client_name))
                .map(client => (
                  <option key={client.id} value={client.id}>
                    {client.client_name} ({client.portfolio_name_asana})
                  </option>
                ))}
            </Select>
          </FormControl>
          <FormControl>
            <FormLabel htmlFor="projet">Projet : </FormLabel>
            <Select id="projet" name="projetId" onChange={handleProjectChange} size={{ base: "sm", md: "md" }}>
              <option value="">-- Choisir --</option>
              {clientProjects.map(project => (
                <option key={project.id} value={project.id}>
                  {project.nom}
                </option>
              ))}
            </Select>
          </FormControl>
          <FormControl>
            <FormLabel htmlFor="task">Tâche : </FormLabel>
            <Select
              id="task"
              name="taskId"
              onChange={e => {
                handleTaskChange(e);
                const selectedTask = tasks.find(task => task.id === parseInt(e.target.value, 10));
                if (selectedTask && selectedTask.task_code === "9999") {
                  setIsOtherTask(true);
                } else {
                  setIsOtherTask(false);
                }
              }}
              size={{ base: "sm", md: "md" }}
            >
              <option value="">-- Choisir --</option>
              {tasks.map(task => (
                <option key={task.id} value={task.id}>
                  {task.task_code} - {task.task_name}
                </option>
              ))}
            </Select>
          </FormControl>
          {isOtherTask && (
            <FormControl>
              <FormLabel htmlFor="taskDescription">Description : </FormLabel>
              <Input
                id="taskDescription"
                name="taskDescription"
                placeholder="Décrivez la tâche"
                value={taskData.taskDescription || ""}
                onChange={handleTaskChange}
                size={{ base: "sm", md: "md" }}
              />
            </FormControl>
          )}
          <FormControl>
            <FormLabel htmlFor="timeSpent">Temps : </FormLabel>
            <Input
              variant="outline"
              placeholder="Temps passé"
              type="time"
              id="timeSpent"
              name="timeSpent"
              value={taskData.timeSpent}
              onChange={handleTaskChange}
              size={{ base: "sm", md: "md" }}
            />
          </FormControl>
          <FormControl display={"flex"} alignItems={"end"} justifyContent={"center"} mt={{ base: 4, md: 0 }}>
            <Button
              backgroundColor={"lightgreen"}
              leftIcon={<CheckIcon />}
              variant={"outline"}
              type="button"
              onClick={handleAddTask}
              size={{ base: "sm", md: "md" }}
              width={{ base: "full", md: "auto" }}
            >
              Ajouter une tache
            </Button>
          </FormControl>
        </Stack>
      </Stack>
    </Container>
  );
}

export default TaskForm;
